import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// core components
// import { JobPortalData } from "../../common";
import { Container } from "reactstrap";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import ProjectBanner from "../../components/Project/ProjectBanner";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import OurLatestBlogs from "../../components/OurLatestBlogs/OurLatestBlogs";
import ContactUsComponent from "../../components/ContactUsComponent/ContactUsComponent";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
import CaseStudyApplications from "../../components/CaseStudy/CaseStudyApplications";
import Fre8ProApplicationDetailContent from "../../components/CaseStudy/Fre8ProApplicationDetailContent";
import SoftwareTeamHunt from "../../components/CaseStudy/SoftwareTeamHunt";
import { getIPGeoLocation } from "../../common/GeneralUtils";
import axios from "axios";
import Toasts from "../../components/Toasts/Toasts";

// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const ProjectBanner = Loadable(
//     lazy(() => import('../../components/Project/ProjectBanner'))
// )
// const CustomerReviews = Loadable(
//     lazy(() => import('../../components/CustomerReviews/CustomerReviews'))
// )
// const OurLatestBlogs = Loadable(
//     lazy(() => import('../../components/OurLatestBlogs/OurLatestBlogs'))
// )
// const ContactUsComponent = Loadable(
//     lazy(() => import('../../components/ContactUsComponent/ContactUsComponent'))
// )
// const FrequentlyAskedQuestions = Loadable(
//     lazy(() => import('../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'))
// )
// const CaseStudyApplications = Loadable(
//     lazy(() => import('../../components/CaseStudy/CaseStudyApplications'))
// )
// const Fre8ProApplicationDetailContent = Loadable(
//     lazy(() => import('../../components/CaseStudy/Fre8ProApplicationDetailContent'))
// )
// const SoftwareTeamHunt = Loadable(
//     lazy(() => import('../../components/CaseStudy/SoftwareTeamHunt'))
// )

const JobPortalDetail = () => {
    const [toasts, setToasts] = useState(null)
    const [JobPortalData, setData] = useState({});

    const getAllJobPortalData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/jobPortalData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        getIPGeoLocation();
        getAllJobPortalData();
    }, [])
    return (
        <div id="main-wrapper">
            <Header />
            <div className="page-wrapper job-portal-detail">
                <div className="container-fluid">
                    <div className="project-page">
                        <ProjectBanner bannerImg={JobPortalData?.bannerImg} data={JobPortalData?.headerData} />
                        <div className="position-relative">
                            <Container>
                                <div className='custom-pending-top'>
                                    <div className="py-5">
                                        <CaseStudyApplications data={JobPortalData?.models} />
                                    </div>
                                    <Fre8ProApplicationDetailContent />
                                </div>
                            </Container>
                        </div>
                        <SoftwareTeamHunt data={JobPortalData?.softwareTeamHunt} />
                        <CustomerReviews />
                        <OurLatestBlogs />
                        <div className="home-contact-page">
                            <ContactUsComponent setToasts={setToasts} />
                        </div>
                        <FrequentlyAskedQuestions faqData={JobPortalData?.FrequentlyAskedQuestionsData} />
                    </div>
                </div>
            </div>
            <Footer />
            {toasts && <Toasts toastsList={toasts} />}
        </div>
    );
}

JobPortalDetail.propTypes = {
    classes: PropTypes.object
};

export default JobPortalDetail;
